import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationOitaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationOita,
);
